import { useEffect, useState } from 'react';
import {
  Users,
  MessageSquare,
  ClipboardCheck,
  Flame,
  Thermometer,
  Snowflake,
  Share2,
} from 'lucide-react';
import SummaryCard from '../components/SummaryCard';
import { fetchDashboardSummary } from '../api/placeholder';

export default function Dashboard() {
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchDashboardSummary()
      .then(setSummary)
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="flex h-[calc(100vh-8rem)] items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-neon-cyan border-t-transparent" />
      </div>
    );
  }

  if (error || !summary) {
    return (
      <div>
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-slate-100">Overview</h1>
          <p className="text-sm text-slate-500">Financial Wellness System Summary</p>
        </div>
        <div className="rounded-2xl border border-surface-600 bg-surface-800 p-8 text-center">
          <p className="text-sm text-neon-pink">{error || 'No data available'}</p>
          <p className="mt-2 text-xs text-slate-500">Make sure the n8n workflow is active and listening.</p>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-slate-100">Overview</h1>
        <p className="text-sm text-slate-500">Financial Wellness System Summary</p>
      </div>

      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
        <SummaryCard
          title="Total Users"
          value={Number(summary.total_users) || 0}
          icon={Users}
          color="cyan"
        />
        <SummaryCard
          title="Total Conversations"
          value={Number(summary.total_conversations) || 0}
          icon={MessageSquare}
          color="purple"
        />
        <SummaryCard
          title="Completed Checks"
          value={Number(summary.completed_checks) || 0}
          icon={ClipboardCheck}
          color="green"
        />
        <SummaryCard
          title="HOT Leads"
          value={Number(summary.hot_leads) || 0}
          icon={Flame}
          color="pink"
        />
        <SummaryCard
          title="WARM Leads"
          value={Number(summary.warm_leads) || 0}
          icon={Thermometer}
          color="amber"
        />
        <SummaryCard
          title="COLD Leads"
          value={Number(summary.cold_leads) || 0}
          icon={Snowflake}
          color="blue"
        />
        <SummaryCard
          title="Total Referrals"
          value={Number(summary.total_referrals) || 0}
          icon={Share2}
          color="purple"
        />
      </div>
    </div>
  );
}
